
import {StrategyBaseClass} from './strategy-base-class.js'


export class GmbService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 11;
  }
  getTypeString() {
    return 'gmb';
  }
  getAllTasksTypes() {
    return [34];
  }
  getPublicTaskTypes() {  // For favorites filtering
    return [34];
  }
  getTaskTypeString(taskType) {
    let mapping = {
      34 : 'gmb/msg'
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    let mapping = {
      34 : 'gmb-msg'
    };
    return mapping[taskType];
  }

  canHaveSurveys() {
    return false;
  }

  getEditorConfiguration(isPrivate) {
    return {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*',
    };
  }

  static GmbFactory($translate) {
    return new GmbService($translate);
  }

  mustCheckIfMessageDeleted(isPrivate) {
    // All messages are public for GMB, so always check if message was deleted
    return true;
  }
}
GmbService.GmbFactory.$inject = ['$translate'];
